import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_DisassociateFacesCommand, se_DisassociateFacesCommand } from "../protocols/Aws_json1_1";
export { $Command };
export class DisassociateFacesCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("RekognitionService", "DisassociateFaces", {})
    .n("RekognitionClient", "DisassociateFacesCommand")
    .f(void 0, void 0)
    .ser(se_DisassociateFacesCommand)
    .de(de_DisassociateFacesCommand)
    .build() {
}
